import { arrType, datatypes, inputTypes } from "data/globalData";

/** Fixed values sent with every CleverTap push (shown in UI note, not as inputs). */
export const CLEVERTAP_FIXED_FIELD_VALUES = {
	creator: "Rarebox",
	email: "yogesh.r@thehouseofrare.com",
};

export const filterColArry = [
	{
		name: "Table Name",
		key: "table_name",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [],
		},
	},
	{
		name: "Segment Name",
		key: "segment_name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 2,
		group: "",
		placeholder: "Enter segment name",
		default_value: "",
	},
];


export const clevertapLogsTableColumns = [
	{
		name: "Id",
		key: "id",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: true },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
	},
	{
		name: "User",
		key: "user_email",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 2,
		group: "",
		placeholder: "",
		default_value: "",
	},
	{
		name: "Table Name",
		key: "table_name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 3,
		group: "",
		placeholder: "",
		default_value: "",
	},
	{
		name: "Dataset",
		key: "dataset_id",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 4,
		group: "",
		placeholder: "",
		default_value: "",
	},
	{
		name: "Segment Name",
		key: "segment_name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 5,
		group: "",
		placeholder: "",
		default_value: "",
	},
	{
		name: "CleverTap Email",
		key: "email",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 6,
		group: "",
		placeholder: "",
		default_value: "",
	},
	{
		name: "Creator",
		key: "creator",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 7,
		group: "",
		placeholder: "",
		default_value: "",
	},
	{
		name: "Filename",
		key: "filename",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 8,
		group: "",
		placeholder: "",
		default_value: "",
	},
	{
		name: "Row Count",
		key: "row_count",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 9,
		group: "",
		placeholder: "",
		default_value: "",
	},
	{
		name: "CleverTap Segment ID",
		key: "clevertap_segment_id",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 10,
		group: "",
		placeholder: "",
		default_value: "",
	},
	{
		name: "Replace",
		key: "replace",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 11,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				{ name: "Yes", key: true },
				{ name: "No", key: false },
			],
		},
	},
	{
		name: "Status",
		key: "status",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 12,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				{ name: "Processing", key: "Processing" },
				{ name: "Success", key: "Success" },
				{ name: "Failed", key: "Failed" },
			],
		},
	},
	{
		name: "Message",
		key: "message",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 13,
		group: "",
		placeholder: "",
		default_value: "",
	},
	{
		name: "Created At",
		key: "created_at",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 14,
		group: "",
		placeholder: "",
	},
	{
		name: "Updated At",
		key: "updated_at",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 15,
		group: "",
		placeholder: "",
	},
];